<template>
    <div class="wrapper">
        <div class="top-content">
            <h3 class="title">Amount</h3>
            <div class="min_max">
                ₹{{maxAmount}}
            </div>            
            <div class="fense"></div>
            <div class="info-list">
                <div class="il-element">Lending time: <em v-text="obj.loanProcessingTime"></em></div>
                <div class="il-element">Period: <em v-text="obj.period"></em></div>
            </div>
            <div class="info-list">
                <div class="il-element">Overall rating: <em v-text="obj.score"></em></div>
                <div class="il-element">Interest: <em v-text="obj.interestRate + '%/day'"></em></div>
            </div>
        </div>
        <div class="requirement">
            <h3 class="section-title">Requirement</h3>
            <ul class="req-list">
                <li class="req-element" v-for="(item, ind) in requirements.list" :key="ind">
                    <span v-text="`${ind+1}、${item}`"></span>
                </li>
            </ul>
        </div>
        <div class="desciption">
            <h3 class="section-title">Product Eligibility</h3>
            <ul class="req-list">
                <li class="req-element" v-for="(item, ind) in elig.list" :key="ind">
                    <span v-text="`${ind+1}、${item}`"></span>
                </li>
            </ul>
        </div>
        <div class="btn-container">
            <a class="btn-submit" @click.prevent="submit">APPLY NOW</a>
        </div>
    </div>
</template>
<style lang="less" scoped>
.wrapper{
    padding: 50px;
    .amount-list{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background:rgba(255,255,255,0.9);
        border-radius: 15px;;
        .amount-element{
            text-align:center;
            width: 150px;
            padding:30px;
            color:#A59BB3;
            font-size: 28px;            
            &:hover{
                color:#FF8143
            }
        }
        
    }
    .top-content{
        position:relative;
        width: 594px;
        height: 320px;
        background:url("~assets/images/product_bg.png") no-repeat;
        background-size: 100% 100%;
        padding:40px 30px;
        .title{
            text-align: center;
            font-size: 24px;
            color:#fff
        }
        .min_max{
            color:#fff;
            font-size: 56px;
            text-align: center;
            margin-top: 25px;
        }
        .fense{
            width:100%;
            margin: 50px 0 50px 0;
            border-top:2px dashed #fff
        }
        .info-list{
            display: flex;
            justify-content: space-between;
            margin-bottom: 40px;            
            .il-element{
                &:last-child{
                    float:right;
                }
                font-size: 24px;
                color:#fff;
                text-align: left;
                width: 50%;
                float:left;
                em{
                    font-weight: 700;
                    font-size: 26px;
                }                
            }            
        }

    }
 
    .requirement{
        margin-top: 50px;
        padding-bottom: 30px;
        border-bottom: 2px solid #EFEEF1;
        .section-title{
            color:#160544;
            font-size: 36px;
        }
        .req-list{
            background:#F9F9FB;
            padding: 25px;
            margin-top: 20px;
            border-radius: 15px;
            .req-element{
                color:#A59BB3;
                font-size: 30px;
                margin-bottom: 20px;
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
    }
    .desciption{
        padding-top: 30px;
        .section-title{
            color:#160544;
            font-size: 36px;
            margin-bottom: 30px;
        }
        .dc{
            background:#F9F9FB;
            padding: 25px; 
            color:#A59BB3;
            font-size: 30px;
        }
        .req-list{
            background:#F9F9FB;
            padding: 25px;
            margin-top: 20px;
            border-radius: 15px;
            .req-element{
                color:#A59BB3;
                font-size: 30px;
                margin-bottom: 20px;
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
    }
    .btn-container{
        position:fixed;
        bottom:50px;
        left:0;
        width: 100%;
        height: 96px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#FF8143;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
        }
    }
}
</style>
<script>
import { productInfo } from '@api/index'
import { onMounted,reactive,ref } from 'vue'
import {useRouter} from 'vue-router'
export default {
    setup () {                
        const router = useRouter()
        const route = router.currentRoute
        const minAmount = ref(0)
        const maxAmount = ref(0)
        const list_show = ref(false)
        const clicked = ref(false)
        let obj = reactive({
            loanProcessingTime:'',
            period: '',
            serviceRate:'',
            interestRate: '',
            score: '',
            slogan: '',
            periodList:['']
        })
        const requirements = reactive({
            list:[]
        })
        const elig = reactive({
            list:[]
        })
        onMounted(async ()=>{
            const data = await productInfo({
                id: route.value.params.pid
            }) 
            elig.list = data.data.detail[0].content
            requirements.list = requirements.list.concat(data.data.detail[1].content) 
            obj = Object.assign(obj, data.data) 
            minAmount.value = data.data.amountList[0]       
            maxAmount.value = data.data.amountList[data.data.amountList.length - 1]                                   
        })
        const submit = async () => {
            if(clicked.value)return
            clicked.value = true  
            router.push({
                "path":'/auth/index',
                "query":{
                    "pid":route.value.params.pid
                }
            })
        }        
        return {
            obj,
            requirements,minAmount, maxAmount,list_show,submit,elig
        }
    }
}
</script>